import { apiRequest } from "../Component/Utils/ApiHundler";

const apiURL = process.env.REACT_APP_API_URL;

export async function updateStatusInstance(
  OldStatus,
  CurrentStatus,
  NewStatus,
  InstanceId,
  ListOnly,
  token
) {
  const apiUrl = `${apiURL}/admin/document/statusupdate`;

  const data = await apiRequest(apiUrl, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      OldStatus: OldStatus,
      CurrentStatus: CurrentStatus,
      NewStatus: NewStatus,
      InstanceId: InstanceId,
      ListOnly: ListOnly,
    }),
  });

  return data.message.items;
}